import React from "react";
import { createRoot } from "react-dom/client";
import { PromptLibraryApp } from "./PromptLibraryApp";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PromptLibraryApp />
  </React.StrictMode>
);
